import React, { useState } from "react"

import { withFavouritesConfig } from "../../config/FavouriteConfigProvider"
import FavouritesManager from "../FavouritesManager"
import Tile from "./Tile"
import { getFormattedMessage, isLTPM } from "../../../components/shared_components_registration"

const FavouritesTiles = ({ intl, favouriteRunSets = [] }) => {
  const getText = (id, msg) => getFormattedMessage(id, msg, true, intl)
  const [showingManager, setShowingManager] = useState(false)
  const showManager = () => setShowingManager(true)
  const hideManager = () => setShowingManager(false)

  return (
    <>
      <FavouritesManager intl={intl} show={showingManager} onHide={hideManager} />

      <div style={{ textAlign: "center", marginTop: "25px" }}>
        <p
          style={{
            display: favouriteRunSets.length > 0 ? "none" : null,
          }}
        >
          {getText(
            "favourites.no.favourites.message",
            "No favourites yet! Create favourites using the star icon found on graphing pages",
          )}
          &nbsp; (
          <span className={"fa fa-star"} aria-hidden={"true"} />)
        </p>

        <Tile
          name={getText("favourites.manage.favourites", "Manage Favourites")}
          description={getText(
            "favourites.manage.favourites.description",
            "Rename, edit, or delete favourite runs or graphs",
          )}
          icon={"star"}
          onClick={showManager}
          colour={"orange"}
        />

        {favouriteRunSets.map((frr) => (
          <Tile
            key={frr.id}
            link={`${isLTPM ? "/performance-analysis?runs=" : "/graph?runreactors="}${frr.encoded}`}
            icon={"thumb-tack"}
            colour={"var(--lanzalake-red)"} // sets css style
            name={frr["name"]}
            description={frr["description"]}
          />
        ))}
      </div>
    </>
  )
}

export default withFavouritesConfig(FavouritesTiles)
